<template>
  <div>
    <b-card>
      <div slot="header">
        <div class="row d-flex">
          <strong size="md">Retrait de commande entre le&nbsp;</strong>
          <datepicker v-model="rangeStart" format="dd/MM/yyyy" :monday-first=true required language="fr">
          </datepicker>
          <strong>&nbsp;et le&nbsp;</strong>
          <datepicker v-model="rangeEnd" format="dd/MM/yyyy" :monday-first=true required language="fr">
          </datepicker>
        </div>
        <div class="row mt-1">
          <b-button class="col-md-1" v-b-toggle.advanced variant="link">Plus &gt;&gt;</b-button>
          <b-collapse id="advanced" v-model="advancedSearch" class="col-md-12">
            <div class="row mt-2">
              <strong class="col-md-3">Prise de commande entre le&nbsp;</strong>
              <datepicker v-model="orderRangeStart" format="dd/MM/yyyy" :monday-first=true required language="fr" :bootstrapStyling=true>
              </datepicker>
              <b-form-input class="col-md-2" type="time" size="sm" v-model="orderHourStart"></b-form-input>
              <strong>&nbsp;et le&nbsp;</strong>
              <datepicker v-model="orderRangeEnd" format="dd/MM/yyyy" :monday-first=true required language="fr" :bootstrapStyling=true>
              </datepicker>
              <b-form-input class="col-md-2" type="time" size="sm" v-model="orderHourEnd"></b-form-input>
            </div>
          </b-collapse>
        </div>
        <div class="clearfix">
          <div class="float-left">Etat au {{ serverDate }}, {{ commandesCount }}
          </div>
          <b-btn :disabled="!readyForPrinting" class="float-right" size="sm" variant="outline-success" v-on:click="printOrders">
            Imprimer
          </b-btn>
        </div>
      </div><!-- header -->
      <ul>
        <li is="orders-row" v-for="order in customerOrders" v-bind:order="order.order" class="row" v-on:print="doPrint"></li>
      </ul>
    </b-card>
  </div><!-- whole page -->
</template>

<script>
import store from '@/store'
import router from '@/router'
// import _ from 'lodash'
import Datepicker from 'vuejs-datepicker'

var singleOrderRow = {
  template: '<tr><td>{{ item.ref }}</td><td>{{ item.name }} ({{ item.container }})</td><td>{{ item.quantity }} {{ item.unit_type }}</td></tr>',
  props: ['item']
}

var singleDateOrderRow = {
  components: {
    'order-detailled-row': singleOrderRow
  },
  template: '<li class="row"><p class="col-md-12"><strong>{{ item.customer }}</strong>: commande numéro {{ item.order_id }}&nbsp;&nbsp;&nbsp;({{item.operator}})&nbsp;&nbsp;&nbsp;<i class="fa fa-print" style="cursor: pointer" v-on:click="$emit(\'print\', item.order_id )"/></p>' +
  '<p class="col-md-12"><strong>commentaire: {{ item.comment }}</strong></p>' +
  '<div class="col-md-12">' +
  '<table class="table table-bordered table-striped table-sm" style="width=100%;">' +
  '<thead>' +
  '<tr>' +
  '<th style="width: 200px;">Ref</th>' +
  '<th>Intitulé</th>' +
  '<th style="width: 200px;">Qté</th>' +
  '</tr>' +
  '</thead>' +
  '<tbody>' +
  '<tr is="order-detailled-row" v-for="item in item.lines" v-bind:item="item"></tr>' +
  '</tbody>' +
  '</table>' +
  '</div>' +
  '</li>',
  props: ['item']
}

var ordersRow = {
  components: {
    'order-row': singleDateOrderRow
  },
  // template: '<tr><td>{{ order.date }}</td><td colspan="3"><table><tbody><tr is="order-detailled-row" v-for="item in order.items"></tr></tbody></table></td></tr>',
  template: '<li class="col-md-12"><p class="col-md-12">{{ order.date }}</p>' +
  '<ul class="col-md-12">' +
  '<li is="order-row" v-for="singleOrder in order.orders" v-bind:item="singleOrder" class="col-md-12" v-on:print="$emit(\'print\', singleOrder.order_id )">' +
  '</li></ul></li>',
  props: ['order']
}

export default {
  name: 'listing',
  components: {
    'orders-row': ordersRow,
    datepicker: Datepicker
  },
  data: function () {
    return {
      customerOrders: [],
      showModalError: false,
      lastError: '',
      date: '',
      opened: [],
      displayDetailsModal: false,
      displaySpinner: true,
      detailRef: '',
      rangeStart: new Date(),
      rangeEnd: new Date(),
      orderRangeStart: new Date(),
      orderRangeEnd: new Date(),
      serverDate: '',
      commandesCount: '0 commande',
      orderHourStart: '',
      orderHourEnd: '',
      advancedSearch: false,
      src: '',
      srcSingleOrder: '',
      readyForPrinting: false,
      outputConsoleLog: false
    }
  },
  beforeCreate () {
    if (!store.state.isLogged) {
      router.push('/')
    }
  },
  created () {
    this.rangeEnd.setDate(this.rangeStart.getDate() + 7)
    this.orderHourEnd = this.rangeStart.getHours() + ':' + this.rangeStart.getMinutes()
    this.fetchOrders()
  },
  watch: {
    orderRangeStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderRangeEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    rangeStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    rangeEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderHourStart: {
      handler: function () {
        this.onRangeModified()
      }
    },
    orderHourEnd: {
      handler: function () {
        this.onRangeModified()
      }
    },
    advancedSearch: {
      handler: function () {
        this.onRangeModified()
      }
    }
  },
  methods: {
    onRangeModified () {
      // reget data
      this.fetchOrders()
    },
    fetchOrders () {
      this.$Progress.start()
      var req = {from: this.rangeStart.toISOString(), to: this.rangeEnd.toISOString()}
      if (this.advancedSearch) {
        req.orderRangeStart = this.orderRangeStart.toISOString()
        req.orderRangeEnd = this.orderRangeEnd.toISOString()
        req.orderHourStart = this.orderHourStart
        req.orderHourEnd = this.orderHourEnd
      }
      this.readyForPrinting = false
      this.$http.get(process.env.API_URL + '/orders/get-by-customer', {params: req}).then((response) => {
        this.customerOrders = []
        var orderDate = response.body.list
        this.serverDate = response.body.date
        console.log('got ' + Object.keys(orderDate).length)
        var orderCount = 0
        for (var d in orderDate) {
          if (this.outputConsoleLog) {
            console.log('date: ' + d)
          }
          var orders = []
          for (var i in orderDate[d]) {
            var currentOrder = orderDate[d][i]
            if (this.outputConsoleLog) {
              console.log('  customer: ' + currentOrder.customer.trim())
            }
            orders.push(currentOrder)
          }
          orders.sort(function (a, b) { return a.customer.localeCompare(b.customer) })
          this.customerOrders.push({'order': {'date': d, 'orders': orders}})
          orderCount += orders.length
        }
        if (orderCount > 1) {
          this.commandesCount = orderCount + ' commandes'
        } else {
          this.commandesCount = orderCount + ' commande'
        }
        this.$Progress.finish()
      },
      (error) => {
        this.$Progress.fail()
        this.orders = []
        if (error.status === 403) {
          this.$eventHub.$emit('redirectToLogin')
        }
      })
      this.$Progress.start()
      // get pdf
      req.format = 'pdf'
      this.$http.get(process.env.API_URL + '/orders/get-by-customer', {params: req, responseType: 'arraybuffer'}).then((response) => {
        var base64EncodedPDF = response.body
        this.src = base64EncodedPDF
        this.readyForPrinting = true
        this.$Progress.finish()
      },
      (error) => {
        console.log(error)
        this.$Progress.fail()
      })
    },
    printOrders () {
      console.log('print orders')
      var base64EncodedPDF = this.src
      var downloadLink = document.createElement('a')
      // downloadLink.target = '_blank'
      downloadLink.download = 'commandes.pdf'
      // convert downloaded data to a Blob
      var blob = new Blob([base64EncodedPDF], {type: 'application/pdf'})
      // create an object URL from the Blob
      var URL = window.URL || window.webkitURL
      var downloadUrl = URL.createObjectURL(blob)
      // set object URL as the anchor's href
      downloadLink.href = downloadUrl
      // append the anchor to document body
      document.body.append(downloadLink)
      // fire a click event on the anchor
      downloadLink.click()
      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(downloadUrl)
    },
    doPrint (orderId) {
      this.$Progress.start()
      var id = this.activeCustomerName
      console.log('do print for id ' + id + ' / ' + orderId)
      var req = {id: orderId}
      this.$http.get(process.env.API_URL + '/order/print', {params: req, responseType: 'arraybuffer'}).then((response) => {
        var base64EncodedPDF = response.body
        this.srcSingleOrder = base64EncodedPDF
        this.$Progress.finish()
        this.printSingleOrder(orderId)
      })
    },
    printSingleOrder (id) {
      console.log('print clients')
      var base64EncodedPDF = this.srcSingleOrder
      var downloadLink = document.createElement('a')
      // downloadLink.target = '_blank'
      downloadLink.download = 'commande_' + id + '.pdf'
      // convert downloaded data to a Blob
      var blob = new Blob([base64EncodedPDF], {type: 'application/pdf'})
      // create an object URL from the Blob
      var URL = window.URL || window.webkitURL
      var downloadUrl = URL.createObjectURL(blob)
      // set object URL as the anchor's href
      downloadLink.href = downloadUrl
      // append the anchor to document body
      document.body.append(downloadLink)
      // fire a click event on the anchor
      downloadLink.click()
      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink)
      URL.revokeObjectURL(downloadUrl)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Commandes.vue?ca0020b8